class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.scrollThreshold = parseInt(this.dataset.threshold, 10);
    this.scrollUpThreshold = parseInt(this.dataset.scrollUpThreshold, 10);
    this.button = this.querySelector('[data-btt-button]');
    this.lastScrollY = 0;
  }

  connectedCallback() {
    if (window.innerWidth < 1024) {
      this.button.addEventListener('click', () => this.scrollToTop());
      this.handleScroll();
      window.addEventListener('scroll', () => this.handleScroll());
      this.checkZoom();
      window.addEventListener('resize', () => this.checkZoom());
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  handleScroll() {
    const announcementBar = document.querySelector('#shopify-section-static-announcement');
    const siteHeaderElement = document.querySelector('[data-site-header]');
    const siteHeaderWrapper = document.querySelector('#shopify-section-static-header');
    const siteHeader = document.querySelector('[data-site-header-sticky]');
    const mobileNav = document.querySelector('[data-mobile-nav]');
    const mobileNavOverlay = document.querySelector('[data-mobile-nav-overlay]');
    const scrollY = window.scrollY;
    const isAtBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;

    if (scrollY > this.scrollThreshold) {
      announcementBar.style.transform = 'translateY(-100%)';
      siteHeader.style.boxShadow = '0px 6px 4px rgba(128, 128, 128, 0.25)';
      mobileNav.style.top = '0';
      siteHeaderWrapper.style.backgroundColor = 'unset';
      siteHeaderWrapper.style.boxShadow = 'unset';

      mobileNavOverlay.style.transform = 'translateY(-200%)';

      if (scrollY < this.lastScrollY || isAtBottom) {
        this.button.classList.remove('back-to-top__button--hidden');
        siteHeaderElement.style.transform = 'unset';
        siteHeader.style.transform = 'translateY(-80%)';
      } else {
        siteHeader.style.transform = 'translateY(-180%)';
        siteHeaderElement.style.transform = 'translateY(-200%)';
      }
    } else {
      siteHeaderElement.style.transform = 'unset';
      announcementBar.style.transform = 'unset';
      siteHeader.style.transform = 'unset';
      mobileNav.style.top = '0px';
      siteHeaderWrapper.style.backgroundColor = '#FFF';
      siteHeaderWrapper.style.boxShadow = '0px 6px 4px rgba(128, 128, 128, 0.25)';
      siteHeader.style.boxShadow = 'unset';
      this.button.classList.add('back-to-top__button--hidden');
    }

    if (scrollY > this.lastScrollY && !isAtBottom) {
      this.button.classList.add('back-to-top__button--hidden');
    }

    this.lastScrollY = scrollY;
  }

  checkZoom() {
    const targetElement = document.querySelector('.back-to-top');
    if (!targetElement) return

    const zoomLevel = window.devicePixelRatio * 100;

    if (zoomLevel >= 350) {
      targetElement.classList.add('back-to-top--zoomed');
    } else {
      targetElement.classList.remove('back-to-top--zoomed');
    }
  }
}

customElements.define('back-to-top', BackToTop);